// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4774":"c1383c32","6096":"7d426ad6","6493":"fce134d8","8847":"92e7ea31","9642":"fce134d8"}[chunkId] + ".css";
};